import { useMemo } from "react";
import AnswerComponent from "./AnswerComponent";
import { getBestCorrectAnswerIndex } from "../shared/model/GameUtils";
import "./active-game.css";

export default function GivenAnswersList({answers, selectedIndex, onClick = () => {}}) {
	const bestCorrectAnswer = useMemo(() => getBestCorrectAnswerIndex(answers), [answers])

	return (
		<div className="horizontal-container center">
			<table className="no-top-margin fixed-container"><tbody>
			{[...Array(answers.length).keys()].reverse()
				.filter(i => answers[i] !== "NOT_ANSWERED")
				.map(i => 
					<tr key={i} onClick={() => onClick(i)} className={selectedIndex === i ? "marked" : ""}>
						<td className={`padding ${bestCorrectAnswer ===i && "error-row"}`}>
							<AnswerComponent key={i} answers={answers} index={i}/>
						</td>
					</tr>
			)}
			</tbody></table>
		</div>
	)
}